import type { SupportedUiLocale } from '../localization/locales';

export interface UserPreferences {
  ui_locale: SupportedUiLocale | null;
  response_locale: SupportedUiLocale | null;
}

export type UserPreferenceKey = keyof UserPreferences;

export type UserPreferencesUpdate = Partial<UserPreferences>;

export interface TourProgress {
  tour_id: string;
  completed_version: number;
  completed_at: string;
  updated_at: string;
}

export interface TourProgressListResponse {
  tours: TourProgress[];
}

export interface TourCompletionRequest {
  completed_version: number;
}

export interface SavedPrompt {
  id: string;
  customer_id: number | null;
  title: string;
  prompt_text: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface SavedPromptCreateRequest {
  title: string;
  prompt_text: string;
  sort_order?: number;
}

export interface SavedPromptFromChatRequest {
  source_prompt: string;
  source_prompt_local_date?: string;
}

export interface SavedPromptDraft {
  title: string;
  prompt_text: string;
}

export interface SavedPromptUpdateRequest {
  title?: string;
  prompt_text?: string;
  sort_order?: number;
}

export interface SavedPromptOrderUpdateRequest {
  prompt_ids: string[];
}

export const SAVED_PROMPT_TITLE_MAX_LENGTH = 100;
export const SAVED_PROMPT_TEXT_MAX_LENGTH = 4_000;